import BpkLargeCalendarIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/calendar';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';
import type { ButtonClick } from '@shared/ui/types';

import STYLES from './DateRange.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';
import { DATE_FORMAT } from '@shared/utils-universal/i18n/date-formats';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  onClickLink: ButtonClick;
  checkInDate: Maybe<Date>;
  checkOutDate: Maybe<Date>;
  className?: string;
};

const DateRange = ({
  checkInDate,
  checkOutDate,
  className,
  i18n: { formatDate, translate },
  onClickLink,
}: Props) => {
  const checkInLabel = translate('SearchControls_label_CheckIn');
  const checkOutLabel = translate('SearchControls_label_CheckOut');
  return (
    <div
      role="button"
      tabIndex={0}
      onKeyUp={() => {}}
      onClick={onClickLink}
      className={cls('DateRange', className)}
      aria-label={`${checkInLabel} ${checkOutLabel}`}
    >
      <BpkLargeCalendarIcon className={cls('DateRange__icon')} />
      <div className={cls('DateRange__dateText')}>
        <BpkText textStyle={TEXT_STYLES.caption} tagName="p">
          {checkInDate
            ? formatDate(checkInDate, DATE_FORMAT.MONTH_DAY_NO_WEEK_ABBR)
            : '--/--'}
        </BpkText>
        <BpkText textStyle={TEXT_STYLES.caption} tagName="p">
          {checkOutDate
            ? formatDate(checkOutDate, DATE_FORMAT.MONTH_DAY_NO_WEEK_ABBR)
            : '--/--'}
        </BpkText>
      </div>
    </div>
  );
};

export default withI18n(DateRange);
